import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';

import { ConstantsService, InternetBankSettings } from '../../../common/services/constants.service';

declare type ContextDefault = 'only-for-mobile' | 'ad-slider';

@Component({
    selector: 'app-login-header',
    templateUrl: './login-header.component.html',
    styleUrls: ['./login-header.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LoginHeaderComponent implements OnInit {
	@Input()
	public context: ContextDefault;

	@Input()
	public logoColor = '#333';

	public SETTINGS: InternetBankSettings;

	public ngOnInit(): void {
		this.SETTINGS = ConstantsService.SETTINGS;
	}
}
